/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Resources_Features_LocalInputs */

const en_gc_resources_features_local = /** @type {(inputs: Gc_Resources_Features_LocalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rust and WebAssembly power local calculations.`)
};

const zh_gc_resources_features_local = /** @type {(inputs: Gc_Resources_Features_LocalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rust 与 WebAssembly 驱动本地计算。`)
};

/**
* | output |
* | --- |
* | "Rust and WebAssembly power local calculations." |
*
* @param {Gc_Resources_Features_LocalInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_features_local = /** @type {((inputs?: Gc_Resources_Features_LocalInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Features_LocalInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_features_local(inputs)
	return zh_gc_resources_features_local(inputs)
});
export { gc_resources_features_local as "gc.resources.features.local" }